@let comp = comparable();

<ng-template #noData>
  <span class="app-text-danger">N/A</span>
</ng-template>

<calcite-panel
  #panel
  collapsible
  collapsed
  [class.included]="comp.included"
  (calcitePanelToggle)="collapsed.set($event.target.collapsed)"
  class="app-rounded"
>
  <div slot="header-content" (click)="panel.collapsed = !panel.collapsed" class="app-clickable">
    <stack class="gap-1" transparent>
      <h3>{{ comp.property_address }}, {{ comp.city }}</h3>
      <div>
        @if (comp.overall_ranking) {
          <span [class.app-text-success]="comp.overall_ranking <= 6">
            Overall #{{ comp.overall_ranking }}.
          </span>
        }
        {{ comp.explanation }}
      </div>
    </stack>
  </div>

  <stack slot="header-actions-end" direction="horizontal" transparent class="app-pad-x-1">
    @if (comp.included) {
      <calcite-button
        appearance="solid"
        kind="brand"
        icon-start="circle-f"
        (click)="toggle.emit(false)"
      >Included
      </calcite-button>
    } @else {
      <calcite-button
        appearance="outline"
        kind="neutral"
        icon-start="circle"
        (click)="toggle.emit(true)"
      >Include
      </calcite-button>
    }
  </stack>

  <stack transparent class="gap-2 stretch">
    <calcite-table [caption]="'Comparable #' + comp.ranking" bordered>
      <calcite-table-row slot="table-header">
        <calcite-table-header heading="Criterion"/>
        <calcite-table-header heading="Value"/>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Location</calcite-table-cell>
        <calcite-table-cell>{{ comp.property_address }}, {{ comp.city }} ({{ comp.county_name }})
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Property Type</calcite-table-cell>
        <calcite-table-cell>{{ comp.property_type }}</calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Distance</calcite-table-cell>
        <calcite-table-cell>{{ comp.distance_miles | number: '1.1-1' }} mi</calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Units</calcite-table-cell>
        <calcite-table-cell>
          <div class="comparison">
            <span>{{ comp.number_of_units | number }}</span>
            <span class="app-text-info">{{ comp.unit_count_diff | signedDiff: 'units' }}</span>
          </div>
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Year Built</calcite-table-cell>
        <calcite-table-cell>
          @if (comp.year_built) {
            <div class="comparison">
              <span>{{ comp.year_built }}</span>
              <span>{{ comp.year_built_diff | signedDiff: 'yrs' }}</span>
            </div>
          } @else {
            <ng-container [ngTemplateOutlet]="noData"/>
          }
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Sale</calcite-table-cell>
        <calcite-table-cell>
          @if (comp.last_sale_date) {
            {{ comp.last_sale_date }}
            @if (comp.sales_tier) {
              <span class="app-badge">Sales Tier {{ comp.sales_tier }}</span>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="noData"/>
          }
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Sale Price</calcite-table-cell>
        <calcite-table-cell>
          {{ comp.last_sale_price ? (comp.last_sale_price | currency: 'USD' : 'symbol' : '1.0-0') : '—' }}
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Cap Rate</calcite-table-cell>
        <calcite-table-cell>
          @if (comp.cap_rate_available) {
            {{ comp.cap_rate | number: '1.2-2' }}%
            @if (comp.cap_tier) {
              <span class="app-badge">Cap Tier {{ comp.cap_tier }}</span>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="noData"/>
          }
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Avg Rent/Unit</calcite-table-cell>
        <calcite-table-cell>
          @if (comp.avg_rent_per_unit) {
            {{ comp.avg_rent_per_unit | currency: 'USD' : 'symbol' : '1.0-0' }}
            @if (comp.rent_tier) {
              <span class="app-badge">Rent Tier {{ comp.rent_tier }}</span>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="noData"/>
          }
        </calcite-table-cell>
      </calcite-table-row>

      <calcite-table-row>
        <calcite-table-cell>Rent Control / Affordability</calcite-table-cell>
        <calcite-table-cell>{{ comp.affordable_type ?? 'Market rate' }}</calcite-table-cell>
      </calcite-table-row>
    </calcite-table>
  </stack>
</calcite-panel>
